import api from 'api/index'
import T from 'T'
import { handleErrorWithMessage } from 'utils/error'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getCustomerSchedulingAssignment: builder.query({
      query: ({ latitude, longitude, radiusMeters, startDate, endDate, measureIds, materialIds, actionIds, businessLines }) => ({
        url: '/api/v1/core/configured-service/scheduling/assignment',
        method: 'GET',
        params: {
          latitude,
          longitude,
          radiusMeters,
          startDate,
          endDate,
          measureIds,
          materialIds,
          actionIds,
          businessLines,
        },
      }),
      // Unreported, the map just empties and the spinner clears, reading as "no services nearby".
      onQueryStarted: async (_arg, { queryFulfilled }) => {
        try {
          await queryFulfilled
        } catch ({ error }) {
          // queryFulfilled rejects with a lifecycle wrapper; the status and body are on `error`.
          handleErrorWithMessage(error, T.FAILED_TO_LOAD_SERVICES)
        }
      },
    }),
    getRoutesByDay: builder.query({
      query: ({ latitude, longitude, radiusMeters, startDate, endDate, measureIds, materialIds, actionIds, businessLines }) => ({
        url: '/api/v1/core/configured-service/scheduling/routes-by-day',
        method: 'GET',
        params: {
          latitude,
          longitude,
          radiusMeters,
          startDate,
          endDate,
          measureIds,
          materialIds,
          actionIds,
          businessLines,
        },
      }),
      // Its own message: when only this fails the markers still draw, in the fallback colour.
      onQueryStarted: async (_arg, { queryFulfilled }) => {
        try {
          await queryFulfilled
        } catch ({ error }) {
          handleErrorWithMessage(error, T.FAILED_TO_LOAD_ROUTES)
        }
      },
    }),
  }),
})

export const { useLazyGetCustomerSchedulingAssignmentQuery, useLazyGetRoutesByDayQuery } = extendedApi
